import { getMethodCall, postMethodCall, postMethodCallWithFileStream } from "./methods";
import { endpoints } from "./endpoints";


export const fetchFeedback = async(incidentRefNo)=>{
    const deviceId = "aeaaa9d7-20cc-4b0b-a9fe-45b9e41051a7";
    const payLoad ={Id:incidentRefNo, PhoneId:deviceId}
    const headers={'Content-Type': 'application/json'}
    const response = await postMethodCall(endpoints.getFeedback, payLoad, headers)
    return response;
}

export const postReport = async(reportObject)=>{
    const deviceId = "aeaaa9d7-20cc-4b0b-a9fe-45b9e41051a7";
    const payLoad ={...reportObject, PhoneId:deviceId}
    const headers={"Content-Type":"multipart/form-data"}
    const response = await postMethodCallWithFileStream(endpoints.submitIncident, payLoad, headers)
    return response;
}

export const fetchMetaData = async()=>{
    const response = await getMethodCall(endpoints.getMetaData)
    return response;
}